export default __webpack_public_path__ + "static/media/kp.c00c2449.svg";